export default "__VITE_ASSET__tOVoO4dK__"